import secureApi from "../services/secureApi";


export const getContactListApi = async (page = 1, limit = 10) => {
  try {
    const response = await secureApi.post(
      "/contactUs/admin/list",
      {
        page,
        limit,
      }
    );

    return response.data;
  } catch (error) {
    console.error("getContactListApi error:", error);

    return {
      data: [],
      pagination: {
        totalPages: 0,
        currentPage: 1,
        totalItems: 0,
      },
    };
  }
};

export const getContactById = async (id) => {
  try {
    const response = await secureApi.get(
      `/contactUs/view/${id}`
    );

    return response.data;
  } catch (error) {
    console.error("getContactById error:", error);
    throw error;
  }
};